import { COLORS } from "./constants"

export function buildColorMap(keys, colors = COLORS) {
  const unique = [...new Set(keys.filter(Boolean))].sort()
  if (unique.length > colors.length) {
    console.warn(`buildColorMap: ${unique.length} unique keys exceed available (${colors.length}), colors will repeat`)
  }
  const map = new Map()
  unique.forEach((key, i) => {
    map.set(key, colors[i % colors.length])
  })
  return map
}

export function colorList(count, colors = COLORS) {
  if (count > colors.length) {
    console.warn(`colorList: ${count} items exceed available colors (${colors.length}), colors will repeat`)
  }
  return Array.from({ length: count }, (_, i) => colors[i % colors.length])
}
